<template>
  <article class="flex flex-col">
    <div class="mb-[120px] flex gap-[20px]">
      <div class="flex flex-col xl:w-3/4 2xl:w-4/5">
        <BaseTheContentBreadcrumbs :current-page-title="audio?.title" />
        <div class="mb-[65px] flex flex-col lg:flex-row">
          <CommonBlocksImageArticleBlock
            v-if="audioLecture?.data?.value?.image"
            class="mb-4 lg:mb-0 lg:mr-[32px]"
            is-social
            is-lecture
            :data="audioLecture?.data?.value"
            :published-at="audioLecture?.data?.value?.published_at"
            :src="audioLecture?.data?.value?.image?.src"
          />
          <div class="flex w-full flex-col lg:w-2/3">
            <h1
              class="mb-[28px] text-[32px] font-medium leading-[38px]"
              v-text="audioLecture?.data?.value?.title"
            />
            <div
              class="page-body mb-4"
              v-html="audioLecture?.data?.value?.description"
            />
            <AudioBar
              v-if="audioLecture?.data?.value?.path"
              :file-path="audioLecture?.data?.value?.path"
              :course="audioLecture?.data?.value"
              class="mt-auto"
            />
          </div>
        </div>
        <CommonBlocksNewTagsBlock
          v-if="tags"
          class="mb-[80px]"
          v-bind="{ tags }"
        />
        <ClientOnly>
          <div
            v-if="audioLecture?.data?.value?.authors?.length"
            class="flex flex-col"
          >
            <h3 class="mb-[36px] text-[24px] font-medium">Автор</h3>
            <div class="grid grid-flow-row gap-5">
              <CommonAuthorInfo
                v-for="author in audioLecture.data.value.authors"
                :key="author.id"
                :author="author"
              />
            </div>
          </div>
        </ClientOnly>
      </div>
      <CommonBlocksRightArticleBlock class="xl:w-1/4 2xl:w-1/5" />
    </div>
    <!-- <CommonCommentsBlock
      :comments="audioLecture?.data?.value?.comments"
      :model-type="audioLecture?.data?.value?.model_type"
      :model-id="audioLecture?.data?.value?.id"
    /> -->
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
const route = useRoute();
const { secondsToISO } = helperSeo();
const slug = route?.params?.slug;
const { audioLecture } = useAudioLecturesBySlug(slug);
useErrorHandler(() => audioLecture.failureReason.value?.status);

const tags = audioLecture?.data?.value?.tags;
const audio = computed(() => audioLecture?.data?.value);

const robots = ref('all');
const seo = ref({});
seo.value = audioLecture?.data?.value?.seo;

useHead(() => ({
  title: `${
    audioLecture?.data?.value?.title
      ? audioLecture?.data?.value?.title + ' |'
      : ''
  } Слушать аудиолекции по истории РФ для школьников и студентов`,
  meta: [
    {
      hid: 'og:type',
      property: 'og:type',
      content: 'music.song',
    },
    { property: 'og:title', content: audio.value?.title },
    {
      property: 'og:url',
      content: `${useHostApp()}/listen/lectures/${slug}`,
    },
    {
      property: 'og:image',
      content: `${useHostApp()}${audio.value?.image?.src}`,
    },
    {
      name: 'ya:ovs:upload_date',
      content: audio.value?.published_at,
    },
    {
      hid: 'description',
      name: 'description',
      content: `${
        seo.value?.metadescription ?? audioLecture?.data?.value?.title ?? ''
      }. Слушать аудиолекции по истории РФ для школьников и студентов на сайте Федерального портала истории России.`,
    },
    {
      'http-equiv': 'Last-Modified',
      content: new Date(seo.value?.last_modified).toUTCString(),
    },
    {
      property: 'og:description',
      content: `${
        seo.value?.metadescription ?? audioLecture?.data?.value?.title ?? ''
      }. Слушать аудиолекции по истории РФ для школьников и студентов на сайте Федерального портала истории России.`,
    },
    {
      hid: 'robots',
      name: 'robots',
      content: robots.value,
    },
  ],
}));

useSchemaOrg(() => [
  defineArticle({
    uploadDate: new Date(audio.value?.published_at),
    '@type': 'AudioObject',
    duration: secondsToISO(audio.value?.metadata?.duration),
    bitrate: `${(audio.value?.metadata?.bitrate / 1000)?.toFixed(0)} kbps`,
    contentUrl: `${useHostApp()}${audio.value?.path}`,
    thumbnailUrl: `${useHostApp()}${audio.value?.image?.src}`,
    author: audio.value?.authors?.map((author) => ({
      name: author.fullname,
      url: `${useHostApp()}/authors/${author.slug}`,
      sameAs: `${useHostApp()}/authors/${author.slug}`,
      description: author.description,
      ...(author?.image.is_blank && {
        image: {
          '@type': 'ImageObject',
          url: `${useHostApp()}${author.image.preview}`,
          width: 400,
          height: 400,
          caption: author.image.alt || '',
        },
      }),
    })),
  }),
]);
</script>
